import { render } from "./DialogInvalidArea.vue?vue&type=template&id=feb3d936"
import script from "./DialogInvalidArea.vue?vue&type=script&lang=js"
export * from "./DialogInvalidArea.vue?vue&type=script&lang=js"
script.render = render

export default script